import React, { useEffect } from "react";
import utils from "../../common/utils.js";

const DFESummary = ( props ) => {
	const data = props.data;
	const filterValues = data.filterValues;
	const setFilterValues = data.setFilterValues;
	const widgetModel = data.widgetModel;
	const widgetOptions = widgetModel?.options;
	const getPosts = data.getPosts;
	const setPage = data.setPage;
	let selectedMockFilters = [];
	const activeFilters = Object.values(filterValues).some(value => 0 < value.length );

	// if in editor, filters
	if (widgetModel.isStatic){
		if (widgetModel.staticData?.filters) {
			selectedMockFilters = selectedMockFilters.concat(widgetModel.staticData?.filters);
		}
		if (selectedMockFilters.length) {
			selectedMockFilters = selectedMockFilters.filter((filter) => widgetOptions.filters.some((elem) => filter.id === elem.id) );
		}
	}

	const removeSelection = (e, filterId ) => {
		const value = String(e.currentTarget.getAttribute('data-name'));
		let currentFilterValues = filterValues[filterId] || [];
		let newFilterValues = {}
			newFilterValues[filterId] = currentFilterValues.filter(item  => item.value !== value);
		setFilterValues({ ...filterValues, ...newFilterValues });
		setPage(1);
		getPosts();
	}

	useEffect(() => {
		const clearAll = () => {
			let newFilterValues = {};
			for (const filter in filterValues) {
				if (Array.isArray(filterValues[filter.id])) {
					newFilterValues[filter.id] = []; // Empty out the array
				}
			}
			setFilterValues({...filterValues, ...newFilterValues});
			getPosts();
		}

		 const clearAllButton = document.getElementById('clearAllButton');

		 clearAllButton.addEventListener('click', clearAll);

		 return () => {
			 clearAllButton.removeEventListener('click', clearAll);
		 };

	}, []);

	const renderPillBox = () => {
		if( Object.keys(filterValues).length === 0) {
			return '';
		}
		return (
			<div className="dfe-summary-pills">
				{Object.keys(filterValues).map((filter, index) =>(
					utils.toArray(filterValues[filter]).map((item, itemIndex) => (
					<button key={filter + '-' + itemIndex} className="dfe-summary-pill" data-name={item.value} data-category={filter} onClick={e => removeSelection(e, filter)}>
						<span className="dfe-summary-pill-text">{item.label}</span>
						<svg version="1.1" width="6px" height="6px" xmlns="http://www.w3.org/2000/svg">
							<g transform="matrix(1 0 0 1 -188 -60 )">
							<path d="M 3.8364485981308407 3.0102803738317756  L 5.805607476635514 4.979439252336448  C 6.039252336448598 5.213084112149533  6.039252336448598 5.591588785046728  5.805607476635514 5.8252336448598125  C 5.689719626168224 5.942056074766355  5.536448598130841 6  5.383177570093458 6  C 5.229906542056075 6  5.077009345794393 5.941588785046729  4.960373831775701 5.824766355140187  L 2.9906542056074765 3.8560747663551407  L 1.0211214953271028 5.824299065420561  C 0.9042990654205608 5.942056074766355  0.7512149532710279 6  0.5981308411214953 6  C 0.4450467289719627 6  0.2921495327102804 5.942056074766355  0.17523364485981308 5.824299065420561  C -0.05841121495327102 5.590654205607477  -0.05841121495327102 5.212149532710281  0.17523364485981308 4.978504672897197  L 2.1453271028037384 3.008411214953271  L 0.17523364485981308 1.0392523364485982  C -0.05841121495327102 0.8056074766355139  -0.05841121495327102 0.42710280373831766  0.17523364485981308 0.19345794392523355  C 0.40887850467289716 -0.040186915887850574  0.7873831775700935 -0.040186915887850574  1.0210280373831777 0.19345794392523355  L 2.9906542056074765 2.1644859813084114  L 4.960747663551402 0.1943925233644861  C 5.194392523364486 -0.039252336448598026  5.572897196261682 -0.039252336448598026  5.8065420560747665 0.1943925233644861  C 6.040186915887849 0.4280373831775702  6.040186915887849 0.8065420560747665  5.8065420560747665 1.0401869158878507  L 3.8364485981308407 3.0102803738317756  Z "  fill="#005ea2" stroke="none" transform="matrix(1 0 0 1 188 60 )" />
							</g>
						</svg>
					</button>
					))
				))}
			</div>
		)
	}

	return (
		<div className="dfe-summary">
			<div className="dfe-summary-selection-container">
				{renderPillBox(filterValues)}
			</div>
			<div className={`${ activeFilters ? 'show' : 'hide'} dfe-summary-clear-container `}>
				<button className="dfe-summary-clear-button" id="clearAllButton">Clear All</button>
			</div>
		</div>
	)
}

export default DFESummary
